export const SmartwayLogo = () => {
  return (
    <svg
      width="141"
      height="20"
      viewBox="0 0 141 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.3378 0L85.6245 2.8789V2.88068L85.1249 3.4124H85.1218L83.032 5.62955V6.19203H85.6245V10.6892C85.6245 13.6947 87.5242 15.6157 90.4743 15.6157H92.2846V12.5649H90.8989C89.6026 12.5649 88.8874 11.8417 88.8874 10.5084V6.19203H92.2622V3.4124H88.8874V0H88.3378Z"
        fill="#272727"
      />
      <path
        d="M77.3106 3.38975L77.8918 4.90386C78.7633 3.81913 79.8584 3.34455 81.4006 3.34455H82.1828V6.39538H81.043C79.2104 6.39538 78.4951 7.20893 78.4951 9.22021V15.5931H75.2322V3.38975H77.3106Z"
        fill="#272727"
      />
      <path
        d="M32.6452 15.9548C35.7071 15.9548 37.7185 14.3277 37.7185 11.8418C37.7185 8.91393 35.2855 8.46794 33.3359 8.11055L33.2263 8.09044C31.9747 7.86446 30.9467 7.66107 30.9467 6.84752C30.9467 6.14696 31.5501 5.69499 32.5559 5.69499C33.6956 5.69499 34.3661 6.16956 34.3885 7.1413H37.495C37.4727 4.70064 35.5506 3.05095 32.6452 3.05095C29.7399 3.05095 27.7954 4.65545 27.7954 6.96051C27.7954 9.83054 30.2538 10.3503 32.1759 10.6893C33.4498 10.8927 34.5002 11.1413 34.5002 11.9774C34.5002 12.791 33.6733 13.2204 32.7793 13.2204C31.6172 13.2204 30.7903 12.678 30.7679 11.5932H27.5943C27.5943 14.1921 29.628 15.9548 32.6452 15.9548Z"
        fill="#272727"
      />
      <path
        d="M49.6783 5.0619C50.5053 3.88676 51.8686 3.11842 53.4107 3.11842C55.9138 3.11842 57.657 5.0845 57.657 7.95453V15.5929H54.394V8.4969C54.394 6.86979 53.7682 6.01104 52.5838 6.01104C51.1311 6.01104 50.2594 7.09578 50.2594 8.99406V15.5929H47.0858V8.4969C47.0858 6.86979 46.46 6.01104 45.2979 6.01104C43.8229 6.01104 42.9513 7.09578 42.9513 8.99406V15.5929H39.6882V3.3896H41.9679L42.5714 4.90371C43.4206 3.81898 44.7392 3.11842 46.1696 3.11842C47.7116 3.11842 48.9631 3.84157 49.6783 5.0619Z"
        fill="#272727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.7301 4.54245L70.0653 3.38992H72.5014V15.5932H69.9536L69.6631 14.4859C68.635 15.4125 67.294 15.9548 65.752 15.9548C62.1314 15.9548 59.4271 13.1752 59.4271 9.49156C59.4271 5.80799 62.1314 3.05095 65.752 3.05095C67.3164 3.05095 68.6797 3.61591 69.7301 4.54245ZM62.7349 9.49156C62.7349 11.3898 64.1204 12.8361 66.0202 12.8361C67.9198 12.8361 69.3055 11.4124 69.3055 9.49156C69.3055 7.57067 67.9198 6.14696 66.0202 6.14696C64.1204 6.14696 62.7349 7.57067 62.7349 9.49156Z"
        fill="#272727"
      />
      <path
        d="M109.013 3.38994L106.644 10.6893L103.381 3.48034H102.464L99.3355 10.6667L96.9442 3.38994H93.6365L97.6146 15.5932H100.252L102.934 9.2882L105.66 15.5932H108.298L112.231 3.38994H109.013Z"
        fill="#272727"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.603 3.38992L123.268 4.54245C122.217 3.61591 120.854 3.05095 119.29 3.05095C115.669 3.05095 112.965 5.80799 112.965 9.49156C112.965 13.1752 115.669 15.9548 119.29 15.9548C120.832 15.9548 122.173 15.4125 123.201 14.4859L123.491 15.5932H126.04V3.38992H123.603ZM119.558 12.8361C117.658 12.8361 116.273 11.3898 116.273 9.49156C116.273 7.57067 117.658 6.14696 119.558 6.14696C121.458 6.14696 122.843 7.57067 122.843 9.49156C122.843 11.4124 121.458 12.8361 119.558 12.8361Z"
        fill="#272727"
      />
      <path
        d="M137.535 3.38994L134.519 10.9153L131.3 3.38994H127.747L132.864 14.6667L132.82 14.7571C132.083 16.6101 131.68 17.0395 130.094 17.0395H128.976V20H130.318C133.022 20 134.295 18.757 135.748 15.435L141 3.38994H137.535Z"
        fill="#272727"
      />
      <path
        d="M0 1.30486H0.695662L3.44961 3.30976V12.5893C3.44961 14.0195 4.59949 15.1788 6.01794 15.1788C7.43639 15.1788 8.58627 14.0195 8.58627 12.5893V7.52188C8.58627 4.14967 11.2975 1.41595 14.6419 1.41595C17.9865 1.41595 20.6977 4.14967 20.6977 7.52188V18.696H20.0079L17.2481 16.6808V7.52188C17.2481 6.07064 16.0813 4.89418 14.6419 4.89418C13.2026 4.89418 12.0359 6.07064 12.0359 7.52188V12.5893C12.0359 15.9404 9.34156 18.6571 6.01794 18.6571C2.69433 18.6571 0 15.9404 0 12.5893V1.30486Z"
        fill="#D84B3B"
      />
    </svg>
  );
};
